export function InterviewsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/interviews.svg'"></ng-include>`
    }
}